import { Injectable } from '@angular/core';
declare let THREE: any;
import { WallHelperService } from './wall/wall-helper.service';
import { RoomStateManagerService } from './room-state-manager.service';

@Injectable()
export class RoomCornerService {

  constructor(protected wallHelper?: WallHelperService,
    protected roomStateManager?: RoomStateManagerService) { }

  cornerRotationMap = [
    {
      direction: new THREE.Vector3(0.7071067811865475, 0, 0.7071067811865476),
      angle: 0
    },
    {
      direction: new THREE.Vector3(-0.7071067811865475, 0, 0.7071067811865476),
      angle: -1.5707963267948966
    },
    {
      direction: new THREE.Vector3(-0.7071067811865476, 0, -0.7071067811865474),
      angle: -3.141592653589793
    },
    {
      direction: new THREE.Vector3(0.7071067811865475, 0, -0.7071067811865475),
      angle: 1.5707963267948966
    }
  ]

  colliderBoxSize = new THREE.Vector3(20, 500, 20);

  getCornerRotation(direction) {
    var i = 0,
      item,
      dotProduct;
    for (; i < this.cornerRotationMap.length; i++) {
      item = this.cornerRotationMap[i];
      dotProduct = item.direction.dot(direction);
      if (dotProduct >= 0.99 && dotProduct <= 1)
        return item.angle;
    }
    return 0;
  }

  getRotation(wallA, wallB) {
    var wallADirection = wallA.getWorldDirection(new THREE.Vector3());
    var wallBDirection = wallB.getWorldDirection(new THREE.Vector3());
    var sum = wallADirection.add(wallBDirection).normalize();
    return this.getCornerRotation(sum);
  }

  // constructor(private wallHelper: WallHelperService,
  //   private roomStateManager: RoomStateManagerService) { }

  isInCorner(object) {
    var roomPoints = this.roomStateManager.getPoints(),
      count = roomPoints.length,
      colliderBox = new THREE.Box3(),
      objectBox = new THREE.Box3(),
      i = 0;
  }

  snap(obj, wallA, wallB) {
    var collidedPosition = this.wallHelper.snapToWallWithGap(obj, wallA);
    obj.position.copy(collidedPosition);
    collidedPosition = this.wallHelper.snapToWallWithGap(obj, wallB);
    obj.position.copy(collidedPosition);
  }



}



// WEBPACK FOOTER //
// ./src/app/services/room-corner.service.ts